import { Setting, ChatSettingsType } from "./types";

export const transformSettingsToChatSettings = (settingsArray: Setting[]) => {
  const transformed: ChatSettingsType = {};
  settingsArray.forEach((setting) => {
    const key = setting.name.replace(/\s+/g, "");
    transformed[key] = {
      ...setting,
      selected_option: setting.default_option,
    };
  });
  return transformed;
};

export const transformChatSettingsToSettingsArray = (
  chatSettings: ChatSettingsType
): Setting[] => {
  return Object.values(chatSettings).map(
    ({
      name,
      type,
      display_type,
      available_options,
      default_option,
      selected_option,
    }) => ({
      name,
      type,
      display_type,
      available_options,
      default_option: selected_option ?? default_option,
    })
  );
};
